require('dom-slider');

const { slideToggle } = window.domSlider;

const accordions = document.querySelectorAll('.block-accordion');

const toggleShowMore = (e) => {
	e.preventDefault();

	e.currentTarget.classList.toggle('active');

	slideToggle({
		element: e.currentTarget.previousElementSibling,
		slideSpeed: 400,
		easing: 'ease-in-out',
	});
};

const initAccordion = () => {
	if (accordions.length) {
		accordions.forEach((accordion) => {
			if (accordion.hasAttribute('data-limit')) {
				const limit = accordion.getAttribute('data-limit');

				if (limit > 0) {
					const accordionItems = accordion.querySelectorAll(
						'.block-accordion__item'
					);

					if (
						accordionItems.length &&
						accordionItems.length > limit
					) {
						const accordionItemWrapper =
							document.createElement('div');

						accordionItemWrapper.classList.add(
							'block-accordion__more-items',
							'DOM-slider-hidden'
						);

						accordionItemWrapper.setAttribute('tabindex', '-1');

						accordionItems.forEach((accordionItem, index) => {
							if (index >= limit) {
								accordionItemWrapper.appendChild(accordionItem);
							}
						});

						const showMoreButton = document.createElement('button');
						const showMoreTextSpan = document.createElement('span');
						const showLessTextSpan = document.createElement('span');
						const showMoreText =
							document.createTextNode('Show More');
						const showLessText =
							document.createTextNode('Show Less');

						showMoreTextSpan.classList.add(
							'block-accordion__show-more-text'
						);
						showLessTextSpan.classList.add(
							'block-accordion__show-less-text'
						);

						showMoreTextSpan.appendChild(showMoreText);
						showLessTextSpan.appendChild(showLessText);
						showMoreButton.appendChild(showMoreTextSpan);
						showMoreButton.appendChild(showLessTextSpan);

						showMoreButton.classList.add(
							'block-accordion__show-more-button',
							'c-btn',
							'c-btn-secondary',
							'c-btn--small'
						);

						accordion.appendChild(accordionItemWrapper);
						accordion.appendChild(showMoreButton);

						showMoreButton.addEventListener(
							'click',
							toggleShowMore
						);
					}
				}
			}
		});
	}
};

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		initAccordion();

		window.onbeforeprint = null;
		window.onafterprint = null;
	},
	loaded() {},
	resized() {},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
